import React, { useState, useEffect } from 'react';
//import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { NavLink, useLocation } from 'react-router-dom';
import './NavMenu.css';

const NavMenu =()=> {
    const location = useLocation(); 

    const [currentroute, setcurrentroute] = useState(location.pathname);

    useEffect(() => {
        setcurrentroute(location.pathname);
    }, [location]);

  //render() {
      return (
          //<header>
          //  <Navbar classNameName="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
          //    <NavbarBrand tag={Link} to="/">Indigo.IN.WebFE</NavbarBrand>
          //    <NavbarToggler onClick={this.toggleNavbar} classNameName="mr-2" />
          //    <Collapse classNameName="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
          //      <ul classNameName="navbar-nav flex-grow">
          //          <NavItem>
          //          <NavLink tag={Link} classNameName="text-dark" to="/">Home</NavLink>
          //          </NavItem>
          //          <NavItem>
          //          <NavLink tag={Link} classNameName="text-dark" to="/counter">Counter</NavLink>
          //          </NavItem>
          //          <NavItem>
          //          <NavLink tag={Link} classNameName="text-dark" to="/fetch-data">Fetch data</NavLink>
          //          </NavItem>
          //          <NavItem>
          //                      <NavLink tag={Link} classNameName="text-dark" to="/friend-and-family">Friends & Family</NavLink>
          //          </NavItem>
          //      </ul>
          //    </Collapse>
          //  </Navbar>
          //</header>
          <div className="NavMain">
          <nav className="navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar b-watcho">
              <a className="navbar-brand mr-0 mr-md-2" href="https://www.watcho.com/">
                  <img src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/logo.svg" className="b-logo" alt="watcho"/>
              </a>

              <div className="navbar-nav-scroll">
                  <ul className="navbar-nav bd-navbar-nav flex-row">
                      <li className="nav-item">
                          <a className="nav-link" href="https://www.watcho.com/" target="_blank" rel="noreferrer">Home</a>
                      </li>

                      {(currentroute.toLowerCase() === "/becomeourpartner" || currentroute.toLowerCase() === "/")  &&
                          <li className="nav-item ">
                                  <NavLink to="/BecomeOurPartner" className={`nav-link ${currentroute.toLowerCase() === "/becomeourpartner" ? "active" : ""}`} >Become our Partner</NavLink >
                          </li>
                      }

                      {(currentroute.toLowerCase() === "/becomeswagcreator" || currentroute.toLowerCase() === "/") &&
                          <li className="nav-item ">
                              <NavLink to="/BecomeSwagCreator" className={`nav-link ${currentroute.toLowerCase() === "/becomeswagcreator" ? "active" : ""}`} >Become a Swag Creator</NavLink>
                          </li>
                      }

                      {(currentroute.toLowerCase() === "/family-and-friends" || currentroute.toLowerCase() === "/customer-info" || currentroute.toLowerCase() === "/thankyou-page" || currentroute.toLowerCase() === "/") &&
                          <li className="nav-item ">
                              <NavLink to="/family-and-friends" className={`nav-link ${currentroute.toLowerCase() === "/family-and-friends" || currentroute.toLowerCase() === "/customer-info" || currentroute.toLowerCase() === "/thankyou-page" ? "active" : ""}`} >Family and Friends</NavLink>
                          </li>
                      }
          </ul>
    </div >
</nav >
          </div>
    );
}

export default NavMenu;
